type QueryParamObject = { [key: string]: string | string[] | number | Date }

export const objectToQueryString = (obj: QueryParamObject): string => {
  return Object.entries(obj)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        const cleanValues = value.filter((item) => item !== undefined && item !== null && item !== '')
        if (cleanValues.length === 0) return null
        return `${encodeURIComponent(key)}=${cleanValues.map((item) => encodeURIComponent(item.toString())).join(',')}`
      }
      if (value === undefined || value === null || value === '') return null
      return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`
    })
    .filter((entry) => entry !== null)
    .join('&')
}
